import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { ToastrService } from 'ngx-toastr';
import { IAtividadeTipoTrabalhoFaseModel, IAtividadeTipoTrabalhoModel } from 'src/app/models/atividade-tipo-trabalho.model';
import { IBaseModel } from 'src/app/models/base.model';
import { AtividadeTipoTrabalhoFaseService } from 'src/app/services/atividade-tipo-trabalho-fase.service';
import { BaseFormComponent } from 'src/app/shared/components/base-form/base-form.component';
import { ModalCancelarComponent } from 'src/app/shared/components/modal-cancelar/modal-cancelar-component';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-fases-form-modal',
  templateUrl: './fases-form-modal.component.html',
  styleUrls: ['./fases-form-modal.component.scss']
})
export class FasesFormModalComponent extends BaseFormComponent implements OnInit {
  public titulo: string = "Adicionar";
  public model: IAtividadeTipoTrabalhoFaseModel = {} as IAtividadeTipoTrabalhoFaseModel;
  public listaAtividadeTipoTrabalho = [] as IAtividadeTipoTrabalhoModel[];
  public fecharModal: boolean = false;

  atividadeTipoTrabalhoId: number;

  public formFase = new FormGroup({
    id: new FormControl({ value: '', disabled: true }),
    nome: new FormControl('', Validators.required),
    quantidadeDias: new FormControl('', Validators.required),
    descricao: new FormControl('', Validators.required),
  });

  constructor(
    route: ActivatedRoute,
    toastr: ToastrService,
    router: Router,
    localeService: BsLocaleService,
    public matDialog: MatDialog,
    private dialogRef: MatDialogRef<FasesFormModalComponent>,
    private atividadeTipoTrabalhoFaseService: AtividadeTipoTrabalhoFaseService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super(route, toastr, router, localeService, matDialog);
    this.atividadeTipoTrabalhoId = data.atividadeTipoTrabalhoId;
    if (data.faseModel)
      this.model = data.faseModel;
  }

  ngOnInit(): void {
    if (this.model.id > 0) {
      this.titulo = "Editar";
      this.novoRegistro = false;
      this.formFase.patchValue(this.model);
    }
  }

  public async salvar(salvarEFechar: boolean) {
    debugger;
    this.submit = true;
    if (this.formFase.invalid)
      return;

    Object.assign(this.model, this.formFase.value);

    try {
      let res: IBaseModel<IAtividadeTipoTrabalhoFaseModel> = null;
      this.model.atividadeTipoTrabalhoId = this.atividadeTipoTrabalhoId;

      if (!this.novoRegistro) {
        res = await this.atividadeTipoTrabalhoFaseService.atualizar(this.model);
      } else {
        res = await this.atividadeTipoTrabalhoFaseService.inserir(this.model);
      }

      if (res.sucesso) {
        Swal.fire({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
          icon: 'success',
          text: res.mensagem.descricao
        });

        if (salvarEFechar == true) {
          this.dialogRef.close(true);
        }
        else {
          this.model = res.dados
          this.novoRegistro = false;
          this.fecharModal = true;
        }
      } else {
        this.exibirMensagemAlerta(res.mensagem.descricao);
      }
    }
    catch (err) {
      this.exibirMensagemErro(err.mensagem.descricao);
    }
  }

  public cancelar() {
    if (this.fecharModal) {
      this.dialogRef.close(true);
    }
    else {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = { interno: true };
      this.matDialog.open(ModalCancelarComponent, dialogConfig).afterClosed();
    }
  }
}
